import React, { FunctionComponent } from 'react';
import VerticalCardLoader from 'syf-component-library/ui/atoms/Loader/Skeleton/VerticalCardLoader';
import './loader.css';

const SkeletonLoader: FunctionComponent = () => {
  return (
    <div className="skeleton-loader-container">
      <VerticalCardLoader className="skeleton-loader" />
    </div>
  );
};

export default SkeletonLoader;
